
import React from 'react'
import logo from '../icons/sojosWestLogo.png'

const Logo = () => {
  return(
    <div id="header">
        <img id="logo" alt='sojos west'src={logo} />
    </div>
  )
}

export default Logo